const routes = [
  // 登录
  {
    meta: { title: '登录' },
    component: () => import('@/views/login'),
    path: '/login'
  },
  // 首页
  {
    path: '/',
    redirect: { path: '/home' }
  },
  {
    meta: { title: '首页' },
    component: () => import('@/views/home'),
    path: '/home'
  },
  // 工作台
  {
    meta: { title: '工作台' },
    component: () => import('@/views/new'),
    path: '/new',
    // 工作台已下线：访问 /new 时默认跳首页(子路由 /new/xxx 仍按各自完整路径匹配)
    redirect: { path: '/home' },
    children: [
      {
        // 工作台页面已下线：访问旧地址 /new/work 时重定向到首页
        path: '/new/work',
        redirect: { path: '/home' }
      },
      {
        meta: { title: '客户' },
        component: () => import('@/views/new/customer'),
        path: '/new/customer',
        redirect: { path: '/new/customer/user' },
        children: [
          {
            meta: { title: '客户列表' },
            component: () => import('@/views/new/customer/user'),
            path: '/new/customer/user'
          },
          {
            meta: { title: '客户成本列表' },
            component: () => import('@/views/new/customer/cost'),
            path: '/new/customer/cost'
          },
          {
            meta: { title: '客户分析表' },
            component: () => import('@/views/new/customer/analyze'),
            path: '/new/customer/analyze'
          }
        ]
      },
      {
        meta: { title: '核算单' },
        component: () => import('@/views/new/verify'),
        path: '/new/verify',
        redirect: { path: '/new/verify/list' },
        children: [
          {
            meta: { title: '核算单列表' },
            component: () => import('@/views/new/verify/list'),
            path: '/new/verify/list'
          },
          {
            meta: { title: '打印核算单' },
            component: () => import('@/views/new/verify/print/verify'),
            path: '/new/verify/print/verify'
          },
          {
            meta: { title: '打印报价单' },
            component: () => import('@/views/new/verify/print/quote'),
            path: '/new/verify/print/quote'
          },
          {
            meta: { title: '打印生产订单' },
            component: () => import('@/views/new/verify/print/order'),
            path: '/new/verify/print/order'
          },
          {
            meta: { title: '打印购销合同' },
            component: () => import('@/views/new/verify/print/contract'),
            path: '/new/verify/print/contract'
          },
          {
            meta: { title: '打印制造流程' },
            component: () => import('@/views/new/verify/print/liucheng'),
            path: '/new/verify/print/liucheng'
          }
        ]
      },
      {
        meta: { title: '订单' },
        component: () => import('@/views/new/order'),
        path: '/new/order',
        redirect: { path: '/new/order/list' },
        children: [
          {
            meta: { title: '订单列表' },
            component: () => import('@/views/new/order/list'),
            path: '/new/order/list'
          }
        ]
      },
      {
        meta: { title: '工程协同' },
        component: () => import('@/views/new/gongcheng'),
        path: '/new/gongcheng',
        redirect: { path: '/new/gongcheng/list' },
        children: [
          {
            meta: { title: '工程协同列表' },
            component: () => import('@/views/new/gongcheng/list'),
            path: '/new/gongcheng/list'
          },
          {
            meta: { title: '打印制造流程' },
            component: () => import('@/views/new/gongcheng/print/liucheng'),
            path: '/new/gongcheng/print/liucheng'
          },
          {
            meta: { title: '打印生产订单' },
            component: () => import('@/views/new/gongcheng/print/order'),
            path: '/new/gongcheng/print/order'
          }
        ]
      },
      {
        meta: { title: '工序' },
        component: () => import('@/views/new/gongxu'),
        path: '/new/gongxu',
        redirect: { path: '/new/gongxu/list' },
        children: [
          {
            meta: { title: '工序列表' },
            component: () => import('@/views/new/gongxu/list'),
            path: '/new/gongxu/list'
          }
        ]
      },
      {
        meta: { title: '工艺' },
        component: () => import('@/views/new/gongyi'),
        path: '/new/gongyi',
        redirect: { path: '/new/gongyi/list' },
        children: [
          {
            meta: { title: '工艺列表' },
            component: () => import('@/views/new/gongyi/list'),
            path: '/new/gongyi/list'
          }
        ]
      },
      {
        meta: { title: '生产班组' },
        component: () => import('@/views/new/banzu'),
        path: '/new/banzu',
        redirect: { path: '/new/banzu/list' },
        children: [
          {
            meta: { title: '生产班组列表' },
            component: () => import('@/views/new/banzu/list'),
            path: '/new/banzu/list'
          }
        ]
      },
      {
        meta: { title: '生产平面图' },
        component: () => import('@/views/new/production/org-layout'),
        path: '/new/production/orgLayout'
      },
      {
        meta: { title: '工艺流程图' },
        component: () => import('@/views/new/production/process-layout'),
        path: '/new/production/processLayout'
      },
      {
        meta: { title: 'PMC订单' },
        component: () => import('@/views/new/pmc'),
        path: '/new/pmc',
        redirect: { path: '/new/pmc/list' },
        children: [
          {
            meta: { title: 'PMC订单列表' },
            component: () => import('@/views/new/pmc/list'),
            path: '/new/pmc/list'
          }
        ]
      },
      {
        meta: { title: '采购' },
        component: () => import('@/views/new/purchase'),
        path: '/new/purchase',
        redirect: { path: '/new/purchase/apply' },
        children: [
          {
            meta: { title: '采购申请' },
            component: () => import('@/views/new/purchase/apply'),
            path: '/new/purchase/apply',
            redirect: { path: '/new/purchase/apply/list' },
            children: [
              {
                meta: { title: '采购申请列表' },
                component: () => import('@/views/new/purchase/apply/list'),
                path: '/new/purchase/apply/list'
              },
              {
                meta: { title: '采购申请打印' },
                component: () => import('@/views/new/purchase/apply/print'),
                path: '/new/purchase/apply/print'
              }
            ]
          },
          {
            meta: { title: '采购订单' },
            component: () => import('@/views/new/purchase/order/list'),
            path: '/new/purchase/order/list'
          },
          {
            meta: { title: '送货单' },
            component: () => import('@/views/new/delivery'),
            path: '/new/delivery',
            redirect: { path: '/new/delivery/list' },
            children: [
              {
                meta: { title: '送货单列表' },
                component: () => import('@/views/new/delivery/list'),
                path: '/new/delivery/list'
              },
              {
                meta: { title: '送货单打印' },
                component: () => import('@/views/new/delivery/print'),
                path: '/new/delivery/print'
              }
            ]
          }
        ]
      },
      {
        meta: { title: '生产工单' },
        component: () => import('@/views/new/renwu'),
        path: '/new/renwu',
        redirect: { path: '/new/renwu/list' },
        children: [
          {
            meta: { title: '生产工单列表' },
            component: () => import('@/views/new/renwu/list'),
            path: '/new/renwu/list'
          },
          {
            meta: { title: '生产工单打印' },
            component: () => import('@/views/new/renwu/print'),
            path: '/new/renwu/print'
          }
        ]
      },
      {
        meta: { title: '委外工单' },
        component: () => import('@/views/new/weiwai'),
        path: '/new/weiwai',
        redirect: { path: '/new/weiwai/list' },
        children: [
          {
            meta: { title: '委外工单列表' },
            component: () => import('@/views/new/weiwai/list'),
            path: '/new/weiwai/list'
          },
          {
            meta: { title: '委外工单打印' },
            component: () => import('@/views/new/weiwai/print'),
            path: '/new/weiwai/print'
          }
        ]
      },
      {
        meta: { title: '库存管理' },
        component: () => import('@/views/new/stock'),
        path: '/new/stock',
        redirect: { path: '/new/stock/inventory/list' },
        children: [
          {
            meta: { title: '库存查询' },
            component: () => import('@/views/new/stock/inventory/list'),
            path: '/new/stock/inventory/list'
          },
          {
            meta: { title: '入库单' },
            component: () => import('@/views/new/stock/stockIn/list'),
            path: '/new/stock/stockIn/list'
          },
          {
            meta: { title: '出库单' },
            component: () => import('@/views/new/stock/stockOut/list'),
            path: '/new/stock/stockOut/list'
          },
          {
            meta: { title: '盘点单' },
            component: () => import('@/views/new/stock/stockCheck/list'),
            path: '/new/stock/stockCheck/list'
          },
          {
            meta: { title: '调拨单' },
            component: () => import('@/views/new/stock/stockTransfer/list'),
            path: '/new/stock/stockTransfer/list'
          },
          {
            meta: { title: '收发存汇总' },
            component: () => import('@/views/new/stock/inventory/sfc'),
            path: '/new/stock/inventory/sfc'
          },
          {
            meta: { title: '仓库' },
            component: () => import('@/views/new/stock/warehouse/list'),
            path: '/new/stock/warehouse/list'
          },
          {
            meta: { title: '仓位' },
            component: () => import('@/views/new/stock/location/list'),
            path: '/new/stock/location/list'
          },
          {
            meta: { title: '仓库平面图' },
            component: () => import('@/views/new/stock/layout'),
            path: '/new/stock/layout'
          }
        ]
      }
    ]
  },
  // 销售管理
  {
    meta: { title: '销售管理' },
    component: () => import('@/views/sale'),
    path: '/sale',
    children: [
      {
        meta: { title: '核算单' },
        component: () => import('@/views/sale/verify'),
        path: '/sale/verify',
        redirect: { path: '/sale/verify/info-list' },
        children: [
          {
            meta: { title: '核算单明细表' },
            component: () => import('@/views/sale/verify/info-list'),
            path: '/sale/verify/info-list'
          },
          {
            meta: { title: '核算单列表' },
            component: () => import('@/views/sale/verify/list'),
            path: '/sale/verify/list'
          },
          {
            meta: { title: '核算单详情' },
            component: () => import('@/views/sale/verify/detail'),
            path: '/sale/verify/detail'
          },
          {
            meta: { title: '核算单打印' },
            component: () => import('@/views/sale/verify/print'),
            path: '/sale/verify/print'
          },
          {
            meta: { title: '产品工艺流程卡' },
            component: () => import('@/views/sale/verify/split'),
            path: '/sale/verify/split'
          }
        ]
      },
      {
        meta: { title: '订单' },
        component: () => import('@/views/sale/order'),
        path: '/sale/order',
        redirect: { path: '/sale/order/info-list' },
        children: [
          {
            meta: { title: '订单明细表' },
            component: () => import('@/views/sale/order/info-list'),
            path: '/sale/order/info-list'
          },
          {
            meta: { title: '订单列表' },
            component: () => import('@/views/sale/order/list'),
            path: '/sale/order/list'
          },
          {
            meta: { title: '生产订单打印' },
            component: () => import('@/views/sale/order/print'),
            path: '/sale/order/print'
          }
        ]
      },
      {
        meta: { title: '送货单' },
        component: () => import('@/views/sale/delivery'),
        path: '/sale/customer',
        redirect: { path: '/sale/delivery/list' },
        children: [
          {
            meta: { title: '送货单列表' },
            component: () => import('@/views/sale/delivery/list'),
            path: '/sale/delivery/list'
          },
          {
            meta: { title: '送货单打印' },
            component: () => import('@/views/sale/delivery/print'),
            path: '/sale/delivery/print'
          }
        ]
      },
      {
        meta: { title: '客户' },
        component: () => import('@/views/sale/customer'),
        path: '/sale/customer',
        redirect: { path: '/sale/customer/user/list' },
        children: [
          {
            meta: { title: '客户列表' },
            component: () => import('@/views/sale/customer/user/list'),
            path: '/sale/customer/user/list'
          },
          {
            meta: { title: '客户成本' },
            component: () => import('@/views/sale/customer/cost/list'),
            path: '/sale/customer/cost/list'
          },
          {
            meta: { title: '客户分析' },
            component: () => import('@/views/sale/customer/analyze/list'),
            path: '/sale/customer/analyze/list'
          }
        ]
      },
      {
        meta: { title: '报价单' },
        component: () => import('@/views/sale/quote'),
        path: '/sale/quote',
        redirect: { path: '/sale/quote/list' },
        children: [
          {
            meta: { title: '报价单列表' },
            component: () => import('@/views/sale/quote/list'),
            path: '/sale/quote/list'
          },
          {
            meta: { title: '报价单详情' },
            component: () => import('@/views/sale/quote/detail'),
            path: '/sale/quote/detail'
          },
          {
            meta: { title: '报价单打印' },
            component: () => import('@/views/sale/quote/print'),
            path: '/sale/quote/print'
          }
        ]
      },
      {
        meta: { title: '销售合同' },
        component: () => import('@/views/sale/contract'),
        path: '/sale/contract',
        redirect: { path: '/sale/contract/list' },
        children: [
          {
            meta: { title: '销售合同列表' },
            component: () => import('@/views/sale/contract/list'),
            path: '/sale/contract/list'
          },
          {
            meta: { title: '销售合同详情' },
            component: () => import('@/views/sale/contract/detail'),
            path: '/sale/contract/detail'
          },
          {
            meta: { title: '销售合同打印' },
            component: () => import('@/views/sale/contract/print'),
            path: '/sale/contract/print'
          }
        ]
      }
    ]
  },
  // 采购管理
  {
    meta: { title: '采购管理' },
    component: () => import('@/views/purchase'),
    path: '/purchase',
    children: [
      {
        meta: { title: '订单' },
        component: () => import('@/views/purchase/apply'),
        path: '/purchase/apply',
        redirect: { path: '/purchase/apply/list' },
        children: [
          {
            meta: { title: '采购申请单' },
            component: () => import('@/views/purchase/apply/list'),
            path: '/purchase/apply/list'
          },
          {
            meta: { title: '采购询价单打印' },
            component: () => import('@/views/purchase/apply/print-inquiry'),
            path: '/purchase/apply/print-inquiry'
          },
          {
            meta: { title: '采购申请单打印' },
            component: () => import('@/views/purchase/apply/print-apply'),
            path: '/purchase/apply/print-apply'
          },
          {
            meta: { title: '采购订单' },
            component: () => import('@/views/purchase/order/list'),
            path: '/purchase/order/list'
          },
          {
            meta: { title: '采购订单打印' },
            component: () => import('@/views/purchase/order/print'),
            path: '/purchase/order/print'
          }
        ]
      },
      {
        meta: { title: '供应商' },
        component: () => import('@/views/purchase/supplier'),
        path: '/purchase/supplier',
        redirect: { path: '/purchase/supplier/user/list' },
        children: [
          {
            meta: { title: '供应商列表' },
            component: () => import('@/views/purchase/supplier/user/list'),
            path: '/purchase/supplier/user/list'
          }
        ]
      }
    ]
  },
  // 财务管理
  {
    meta: { title: '财务管理' },
    component: () => import('@/views/finance'),
    path: '/finance',
    children: [
      {
        meta: { title: '财务' },
        component: () => import('@/views/finance/payin'),
        path: '/finance/payin',
        redirect: { path: '/finance/payin/list' },
        children: [
          {
            meta: { title: '应收列表' },
            component: () => import('@/views/finance/payin/list'),
            path: '/finance/payin/list'
          },
          {
            meta: { title: '财务详情' },
            component: () => import('@/views/finance/payin/detail'),
            path: '/finance/payin/detail'
          },
          {
            meta: { title: '收款单打印' },
            component: () => import('@/views/finance/payin/print'),
            path: '/finance/payin/print'
          },
          {
            meta: { title: '应付列表' },
            component: () => import('@/views/finance/payout/list'),
            path: '/finance/payout/list'
          },
          {
            meta: { title: '银行账户列表' },
            component: () => import('@/views/finance/bank/list'),
            path: '/finance/bank/list'
          }
        ]
      }
    ]
  },
  // 生产管理
  {
    meta: { title: '生产管理' },
    component: () => import('@/views/production'),
    path: '/production',
    children: [
      {
        meta: { title: '生产' },
        component: () => import('@/views/production/order'),
        path: '/production/order',
        redirect: { path: '/production/order/list' },
        children: [
          {
            meta: { title: '订单列表' },
            component: () => import('@/views/production/order/list'),
            path: '/production/order/list'
          },
          {
            meta: { title: '工单列表' },
            component: () => import('@/views/production/process/list'),
            path: '/production/process/list'
          },
          {
            meta: { title: '任务列表' },
            component: () => import('@/views/production/task/list'),
            path: '/production/task/list'
          },
          {
            meta: { title: '打印任务' },
            component: () => import('@/views/production/task/print'),
            path: '/production/task/print'
          },
          {
            meta: { title: '设备列表' },
            component: () => import('@/views/production/she-bei/list'),
            path: '/production/she-bei/list'
          }
        ]
      },
      {
        meta: { title: '加工商管理' },
        component: () => import('@/views/production/processor'),
        path: '/production/processor',
        redirect: { path: '/production/processor/list' },
        children: [
          {
            meta: { title: '加工商列表' },
            component: () => import('@/views/production/processor/list'),
            path: '/production/processor/list'
          }
        ]
      }
    ]
  },
  // 商品管理
  {
    meta: { title: '商品管理' },
    component: () => import('@/views/goods'),
    path: '/goods',
    children: [
      {
        meta: { title: '商品系统' },
        component: () => import('@/views/goods/system'),
        path: '/goods/system',
        redirect: { path: '/goods/system/shang-pin' },
        children: [
          {
            meta: { title: '商品列表' },
            component: () => import('@/views/goods/system/shang-pin/list'),
            path: '/goods/system/shang-pin'
          },
          {
            meta: { title: '商品模板' },
            component: () => import('@/views/goods/system/mu-ban/list'),
            path: '/goods/system/mu-ban'
          },
          {
            meta: { title: '商品字段' },
            component: () => import('@/views/goods/system/zi-duan/list'),
            path: '/goods/system/zi-duan'
          }
        ]
      },
      {
        meta: { title: '商品类目' },
        component: () => import('@/views/goods/category'),
        path: '/goods/category',
        redirect: { path: '/goods/category/list' },
        children: [
          {
            meta: { title: '类目管理' },
            component: () => import('@/views/goods/category/manage'),
            path: '/goods/category/manage'
          },
          {
            meta: { title: '类目维护' },
            component: () => import('@/views/goods/category/set'),
            path: '/goods/category/set'
          },
          {
            meta: { title: '类目列表' },
            component: () => import('@/views/goods/category/list'),
            path: '/goods/category/list'
          }
        ]
      }
    ]
  },
  // 企业管理
  {
    meta: { title: '企业管理' },
    component: () => import('@/views/company'),
    path: '/company',
    children: [
      {
        meta: { title: '组织架构' },
        component: () => import('@/views/company/jiagou'),
        path: '/company/jiagou',
        redirect: { path: '/company/jiagou/department' },
        children: [
          {
            meta: { title: '组织层级' },
            component: () => import('@/views/company/jiagou/department'),
            path: '/company/jiagou/department'
          },
          {
            meta: { title: '工作地点' },
            component: () => import('@/views/company/jiagou/location'),
            path: '/company/jiagou/location',
            redirect: { path: '/company/jiagou/location/list' },
            children: [
              {
                meta: { title: '工作地点列表' },
                component: () => import('@/views/company/jiagou/location/list'),
                path: '/company/jiagou/location/list'
              },
              {
                meta: { title: '工作地点详情' },
                component: () => import('@/views/company/jiagou/location/detail'),
                path: '/company/jiagou/location/detail'
              }
            ]
          }
        ]
      },
      {
        meta: { title: '职位体系' },
        component: () => import('@/views/company/gangwei'),
        path: '/company/gangwei',
        redirect: { path: '/company/gangwei/role' },
        children: [
          {
            meta: { title: '职位管理' },
            component: () => import('@/views/company/gangwei/role'),
            path: '/company/gangwei/role',
            redirect: { path: '/company/gangwei/role/list' },
            children: [
              {
                meta: { title: '职位列表' },
                component: () => import('@/views/company/gangwei/role/list'),
                path: '/company/gangwei/role/list'
              },
              {
                meta: { title: '职位分类' },
                component: () => import('@/views/company/gangwei/role/category'),
                path: '/company/gangwei/role/category'
              }
            ]
          },
          {
            meta: { title: '职级管理' },
            component: () => import('@/views/company/gangwei/level'),
            path: '/company/gangwei/level',
            redirect: { path: '/company/gangwei/level/list' },
            children: [
              {
                meta: { title: '职级列表' },
                component: () => import('@/views/company/gangwei/level/list'),
                path: '/company/gangwei/level/list'
              }
            ]
          },
          {
            meta: { title: '职务管理' },
            component: () => import('@/views/company/gangwei/job'),
            path: '/company/gangwei/job',
            redirect: { path: '/company/gangwei/job/list' },
            children: [
              {
                meta: { title: '职务列表' },
                component: () => import('@/views/company/gangwei/job/list'),
                path: '/company/gangwei/job/list'
              }
            ]
          },
          {
            meta: { title: '文档管理' },
            component: () => import('@/views/company/gangwei/doc'),
            path: '/company/gangwei/doc',
            redirect: { path: '/company/gangwei/doc/list' },
            children: [
              {
                meta: { title: '文档列表' },
                component: () => import('@/views/company/gangwei/doc/list'),
                path: '/company/gangwei/doc/list'
              },
              {
                meta: { title: '文档分类' },
                component: () => import('@/views/company/gangwei/doc/category'),
                path: '/company/gangwei/doc/category'
              }
            ]
          }
        ]
      },
      {
        meta: { title: '员工管理' },
        component: () => import('@/views/company/yuangong'),
        path: '/company/yuangong',
        redirect: { path: '/company/yuangong/huamingce' },
        children: [
          {
            meta: { title: '花名册' },
            component: () => import('@/views/company/yuangong'),
            path: '/company/yuangong/huamingce',
            redirect: { path: '/company/yuangong/huamingce/list' },
            children: [
              {
                meta: { title: '员工列表' },
                component: () => import('@/views/company/yuangong/huamingce/list'),
                path: '/company/yuangong/huamingce/list'
              },
              {
                meta: { title: '员工详情' },
                component: () => import('@/views/company/yuangong/huamingce/detail'),
                path: '/company/yuangong/huamingce/detail'
              }
            ]
          }
        ]
      },
      {
        meta: { title: '档案管理' },
        component: () => import('@/views/company/dangan'),
        path: '/company/dangan',
        redirect: { path: '/company/dangan/jiaoyu/list' },
        children: [
          {
            meta: { title: '教育经历' },
            component: () => import('@/views/company/dangan/jiaoyu/list'),
            path: '/company/dangan/jiaoyu/list'
          },
          {
            meta: { title: '工作经历' },
            component: () => import('@/views/company/dangan/gongzuo/list'),
            path: '/company/dangan/gongzuo/list'
          },
          {
            meta: { title: '家庭成员' },
            component: () => import('@/views/company/dangan/jiating/list'),
            path: '/company/dangan/jiating/list'
          },
          {
            meta: { title: '员工证书' },
            component: () => import('@/views/company/dangan/zhengshu/list'),
            path: '/company/dangan/zhengshu/list'
          },
          {
            meta: { title: '技能特长' },
            component: () => import('@/views/company/dangan/jineng/list'),
            path: '/company/dangan/jineng/list'
          }
        ]
      }
    ]
  },
  // 基础设置
  {
    meta: { title: '基础设置' },
    component: () => import('@/views/base'),
    path: '/base',
    children: [
      {
        meta: { title: '类别管理' },
        component: () => import('@/views/base/category'),
        path: '/base/category',
        redirect: { path: '/base/category/list' },
        children: [
          {
            meta: { title: '类别列表' },
            component: () => import('@/views/base/category/list'),
            path: '/base/category/list'
          }
        ]
      },
      {
        meta: { title: '参数管理' },
        component: () => import('@/views/base/dict'),
        path: '/base/dict',
        redirect: { path: '/base/dict/list' },
        children: [
          {
            meta: { title: '参数列表' },
            component: () => import('@/views/base/dict/list'),
            path: '/base/dict/list'
          },
          {
            meta: { title: '参数详情' },
            component: () => import('@/views/base/dict/detail'),
            path: '/base/dict/detail'
          }
        ]
      },
      {
        meta: { title: '计量单位' },
        component: () => import('@/views/base/unit'),
        path: '/base/unit',
        redirect: { path: '/base/unit/list' },
        children: [
          {
            meta: { title: '单位列表' },
            component: () => import('@/views/base/unit/list'),
            path: '/base/unit/list'
          }
        ]
      },
      {
        meta: { title: '地址管理' },
        component: () => import('@/views/base/address'),
        path: '/base/address',
        redirect: { path: '/base/address/list' },
        children: [
          {
            meta: { title: '地址列表' },
            component: () => import('@/views/base/address/list'),
            path: '/base/address/list'
          }
        ]
      },
      {
        meta: { title: '印章管理' },
        component: () => import('@/views/base/seal'),
        path: '/base/seal',
        redirect: { path: '/base/seal/list' },
        children: [
          {
            meta: { title: '印章列表' },
            component: () => import('@/views/base/seal/list'),
            path: '/base/seal/list'
          }
        ]
      }
    ]
  },
  // 系统设置
  {
    meta: { title: '系统设置' },
    component: () => import('@/views/system'),
    path: '/system',
    children: [
      {
        meta: { title: '员工' },
        component: () => import('@/views/system/account'),
        path: '/system/account',
        redirect: { path: '/system/account/list' },
        children: [
          {
            meta: { title: '员工管理' },
            component: () => import('@/views/system/account/list'),
            path: '/system/account/list'
          },
          {
            meta: { title: '游客列表' },
            component: () => import('@/views/system/account/tourist'),
            path: '/system/account/tourist'
          },
          {
            meta: { title: '部门分配权限' },
            component: () => import('@/views/system/account/detail-folder'),
            path: '/system/account/detail-folder'
          },
          {
            meta: { title: '员工分配权限' },
            component: () => import('@/views/system/account/detail-file'),
            path: '/system/account/detail-file'
          }
        ]
      },
      {
        meta: { title: '岗位' },
        component: () => import('@/views/system/role'),
        path: '/system/role',
        redirect: { path: '/system/role/list' },
        children: [
          {
            meta: { title: '岗位列表' },
            component: () => import('@/views/system/role/list'),
            path: '/system/role/list'
          },
          {
            meta: { title: '岗位详情' },
            component: () => import('@/views/system/role/detail'),
            path: '/system/role/detail'
          },
          {
            meta: { title: '岗位分配权限(第二套)' },
            component: () => import('@/views/system/role/detail-assign'),
            path: '/system/role/detail-assign'
          }
        ]
      },
      {
        meta: { title: '权限' },
        component: () => import('@/views/system/power'),
        path: '/system/power',
        redirect: { path: '/system/power/list' },
        children: [
          {
            meta: { title: '权限列表' },
            component: () => import('@/views/system/power/list'),
            path: '/system/power/list'
          },
          {
            meta: { title: '权限配置' },
            component: () => import('@/views/system/power/config'),
            path: '/system/power/config'
          }
        ]
      },
      {
        meta: { title: '操作日志' },
        component: () => import('@/views/system/logger'),
        path: '/system/logger',
        redirect: { path: '/system/logger/list' },
        children: [
          {
            meta: { title: '操作日志列表' },
            component: () => import('@/views/system/logger/list'),
            path: '/system/logger/list'
          }
        ]
      }
    ]
  },
  // 找不到页面
  {
    meta: { title: '找不到页面' },
    component: () => import('@/views/empty'),
    path: '/empty'
  },
  {
    path: '/*',
    redirect: { path: '/empty' }
  }
]

export default routes
